'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var YoutubeService = (function () {
    function YoutubeService($http) {
        _classCallCheck(this, YoutubeService);

        this.$http = $http;
        this.baseUrl = '/api/youtube/search/';
    }

    _createClass(YoutubeService, [{
        key: 'search',
        value: function search(query) {
            return this.$http.get(this.baseUrl + query).then(function (response) {
                return response.data;
            });
        }
    }]);

    return YoutubeService;
})();

exports['default'] = YoutubeService;

YoutubeService.$inject = ['$http'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/youtube/service/youtube.js
 ** module id = 35
 ** module chunks = 0
 **/